export enum SegmentsTabSelection {
    ThisSegment,
    FullProgram
}

export enum CreditTabSelection {
    Progress,
    ReviewAndExam
}